import React from "react";
import Success from './Success'
import Echec from './Echec'

const Resultat = ({hasError, aide, installation, message, imposable}) => {
    return (
        <div>
            {hasError && <Echec message={message}/>}
            {!hasError && <Success aide={aide} installation={installation} imposable={imposable}/>}
        </div>
    )
}
    
    
export default Resultat